import { isEmpty } from 'ramda';

import getStateHandler from './elementState';
import { getElementState } from './priceControls';
import { getPriceElementsByPage } from './selectors';

const hasPercentage = (htmlPrice) => htmlPrice.includes('%');

const hasNoNumber = (htmlPrice) => {
  const regexp = /\d+([0-9 .,]+)?/;
  const hasNumber = regexp.test(htmlPrice);
  return !hasNumber;
};

const shouldSkipElement = (elementState) => {
  const { htmlPrice } = elementState;

  const rules = [isEmpty, hasPercentage, hasNoNumber];
  const hasInvalidFormat = rules.some((rule) => rule(htmlPrice));

  return hasInvalidFormat;
};

const convertDomElement = (
  priceElement,
  baseCurrency,
  targetCurrency,
  config
) => {
  const currentElementState = getElementState(priceElement);
  const currentState = {
    ...currentElementState,
    selectedTargetCurrency: targetCurrency,
    baseCurrency: baseCurrency,
  };

  if (shouldSkipElement(currentState)) {
    return;
  }

  const stateHandler = getStateHandler(currentState);
  stateHandler.handle(priceElement, currentState, config);
};

const convertPage = (pageType, config) => {
  const priceElements = getPriceElementsByPage(pageType);
  const { baseCurrency, targetCurrency } = config;

  priceElements.forEach((priceElement) => {
    convertDomElement(priceElement, baseCurrency, targetCurrency, config);
  });
};

export { convertPage };
